{/* Auto-generated icon - do not edit */}
import React from 'react'

interface Question2IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const Question2Icon = React.forwardRef<SVGSVGElement, Question2IconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 71 134"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M2.51619 19.4153C4.86379 20.8581 6.37293 19.1636 7.47475 17.9244L7.57923 17.806C10.984 13.9844 15.5254 11.6472 22.3031 10.2252C32.7337 8.0409 41.5479 9.75168 49.255 15.4577C58.9053 22.6046 64.0439 37.6094 55.5168 49.3877C53.2338 52.454 50.5274 55.1786 47.4795 57.4797C43.6419 60.4492 39.5552 63.2438 35.6034 65.9466C34.0407 67.016 32.4775 68.0841 30.9252 69.1658C24.4434 73.5195 19.8762 80.2059 18.1667 87.8432C17.4155 91.1204 16.9484 94.4261 16.4552 97.9258C16.229 99.5227 16.0013 101.152 15.7355 102.821C15.7261 102.886 15.7261 102.951 15.7355 103.016C15.8178 103.602 15.8863 104.221 15.9576 104.863C16.1043 106.55 16.3784 108.222 16.778 109.867C17.3685 112.058 19.2078 113.405 21.6973 113.468H21.8676C22.9291 113.502 23.975 113.206 24.8627 112.622C25.7505 112.036 26.437 111.19 26.8274 110.199C27.4613 108.602 27.8738 106.926 28.0541 105.216C28.2835 103.395 28.4602 101.548 28.632 99.7582C28.8666 97.3052 29.1099 94.769 29.489 92.3056C29.8601 89.6269 30.7753 87.0529 32.1778 84.7437C33.5804 82.4344 35.4404 80.4388 37.6428 78.8808C38.9132 77.9565 40.2008 77.0549 41.4887 76.1534C43.8952 74.4692 46.3843 72.7279 48.717 70.8525L49.2734 70.4063C53.3697 67.1155 57.6047 63.7128 61.2875 59.8684C66.4201 54.6118 69.5196 47.692 70.029 40.3499C70.9889 26.289 65.5498 15.1559 53.8604 7.26032C40.8028 -1.55897 26.5309 -2.08262 10.2326 5.66467C6.79979 7.35614 3.94224 10.0287 2.01932 13.3462C0.564877 15.7413 0.777211 18.3433 2.51619 19.4153Z" fill={color}/>
<path d="M23.8226 118.717C21.558 118.708 19.7396 119.327 18.4912 120.574C17.2293 121.831 16.588 123.651 16.5854 125.985C16.5722 127.104 16.7812 128.215 17.2 129.252C17.6189 130.289 18.2397 131.232 19.0254 132.026C20.2667 133.27 21.9454 133.974 23.6992 133.986C23.7576 133.986 23.8149 133.986 23.8726 133.986C27.5898 133.886 31.0763 130.179 31.1871 126.209C31.216 125.248 31.0519 124.291 30.7042 123.395C30.3564 122.499 29.832 121.682 29.1629 120.994C28.4708 120.274 27.641 119.701 26.7235 119.309C25.806 118.919 24.8195 118.717 23.8226 118.717Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="70" height="134" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

Question2Icon.displayName = 'Question2Icon'
